import './S_Modal.scss';
import { Modal, ModalDialog } from '@mui/joy';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement, ReactNode, useEffect } from 'react';

export interface S_ModalProps extends PropsWithChildren {
  headerText: ReactNode;
  className?: string;
  isOpen: boolean;
  buttons?: ReactNode;
  toggle?: () => void;
  onOpened?: () => void;
}

const ModalHeader = observer(
  (props: PropsWithChildren): ReactElement => (
    <div className='s-modal-header'>
      <div className='s-modal-title'>{props.children}</div>
    </div>
  )
);

const ModalBody = observer((props: PropsWithChildren): ReactElement => <div className='s-modal-body'>{props.children}</div>);

const ModalFooter = observer((props: PropsWithChildren): ReactElement => <div className='s-modal-footer'>{props.children}</div>);

export const S_Modal = observer((props: S_ModalProps): ReactElement => {
  useEffect(() => {
    if (props.isOpen) {
      props.onOpened?.();
    }
  }, [props.isOpen]);

  return (
    <Modal
      open={props.isOpen}
      onClose={(_event: React.MouseEvent<HTMLButtonElement>) => {
        _event.stopPropagation();
        _event.preventDefault();
        props.toggle?.();
      }}
    >
      <ModalDialog className={classNames('s-modal', props.className)}>
        <ModalHeader>{props.headerText}</ModalHeader>
        <ModalBody>{props.children}</ModalBody>
        {props.buttons && <ModalFooter>{props.buttons}</ModalFooter>}
      </ModalDialog>
    </Modal>
  );
});
